import AddingEmployees from '../pages/employees/AddingEmployees'
import ManagingEmployees from '../pages/employees/ManagingEmployees'
import RemovingEmployees from '../pages/employees/RemovingEmployees'
import PersonnelDashboard from '../pages/employees/PersonnelDashboard'
import Appraisals from '../pages/employees/Appraisals'
import OccupationalHealth from '../pages/employees/OccupationalHealth'
import ShiftSwaps from '../pages/employees/ShiftSwaps'
import Subcontractors from '../pages/employees/Subcontractors'
import WorkingWithSubcontractors from '../pages/employees/WorkingWithSubcontractors'
import WorkforceSchedulingPayroll from '../pages/employees/WorkforceSchedulingPayroll'
import RosteringPayroll from '../pages/employees/RosteringPayroll'
import Shifts from '../pages/employees/Shifts'
import PeopleShifts from '../pages/modules/PeopleShifts'
import PersonalTools from '../pages/modules/PersonalTools'
import MandatoryTrainingELearning from '../pages/employees/MandatoryTrainingELearning'
import RecruitmentApplications from '../pages/employees/RecruitmentApplications'
import DbsDrivingLicenceId from '../pages/employees/DbsDrivingLicenceId'

export default [
  {
    id: 'employee-records',
    title: 'Employee Records',
    pages: [
      {
        id: 'people-and-shifts',
        title: 'People and Shifts Overview',
        summary:
          'Manage employees, applications, mandatory training, DBS checks, shift booking, rosters, overtime, pay runs, leave balances, and staff-facing shift tools.',
        component: PeopleShifts,
        tags: ['Personnel', 'Employees', 'Shifts', 'Payroll', 'Training', 'DBS', 'Rota', 'Roster', 'Leave', 'Pending Pay', 'My Work', 'Workforce', 'On Call', 'On-Call'],
      },
      {
        id: 'personnel-dashboard',
        title: 'Workforce Dashboard',
        summary:
          'The workforce dashboard combines headcount, compliance charts, and an Action Centre listing expired training, DBS and driving licence issues, missing ID cards, training uploads, and appraisals awaiting review.',
        component: PersonnelDashboard,
        tags: [
          'Dashboard',
          'Action Centre',
          'Compliance',
          'DBS',
          'Training',
          'ID Cards',
          'Driving Licence',
          'Appraisals',
          'Headcount',
        ],
      },
      {
        id: 'managing-employees',
        title: 'Managing Employees',
        summary:
          'Managing employees in AmbuNet allows your organisation to maintain accurate staff records, control system access, monitor compliance, and coordinate operational readiness across your workforce.',
        component: ManagingEmployees,
        tags: [
          'Staff',
          'Employees',
          'New Employees',
          'Add staff',
          'Applications',
          'New Starter',
          'Manage Access',
          'Radiation Doses',
          'Onboarding Checklist',
        ],
      },
      {
        id: 'recruitment-applications',
        title: 'Recruitment & Applications',
        summary:
          'Get new applicants into AmbuNet: share your application link or QR code, set up application settings, and take applicants through references, interviews, offers and onboarding as a new starter.',
        component: RecruitmentApplications,
        tags: ['Recruitment', 'Applications', 'Applicants', 'Apply', 'Application Link', 'Application Form', 'Careers', 'Jobs', 'Job Advert', 'Vacancy', 'Vacancies', 'Hiring', 'References', 'Referees', 'Interviews', 'Job Offer', 'Onboarding', 'New Starter', 'QR Code', 'Join the Team'],
      },
      {
        id: 'adding-employees',
        title: 'Adding Employees',
        summary:
          'Adding employees in AmbuNet allows you to grant staff access to the system, assign roles, track training, and manage operational readiness across your organisation. You can add staff manually (every new employee needs a base location) or accept applications submitted through your tenant’s recruitment portal, and convert existing subcontractors.',
        component: AddingEmployees,
        tags: ['Employee', 'User', 'Recruitment', 'Base Location', 'Seats', 'Employee Limit', 'Subcontractor Conversion'],
      },
      {
        id: 'removing-employees',
        title: 'Removing Employees',
        summary:
          'When an employee leaves your organisation, AmbuNet allows you to update their status quickly while keeping their full history intact. Removing an employee does not delete their record — it simply marks them as a leaver and prevents them from accessing the system.',
        component: RemovingEmployees,
        tags: ['Employee', 'Delete', 'Sack', 'Terminate', 'Employment'],
      },
      {
        id: 'dbs-driving-licence-id',
        title: 'DBS Checks, Driving Licences & ID',
        summary:
          'Track vetting and identity compliance: the DBS Monitoring dashboard with automated Update Service checks, the failed-checks list and Run Checks Now, driving licence records and periodic licence checks, and staff ID cards.',
        component: DbsDrivingLicenceId,
        tags: [
          'DBS',
          'DBS Checks',
          'Update Service',
          'Vetting',
          'Driving Licence',
          'Licence Checks',
          'Endorsements',
          'ID Cards',
          'Compliance',
        ],
      },
      {
        id: 'appraisals',
        title: 'Appraisals',
        summary:
          'Staff appraisals in AmbuNet: enabling and scheduling appraisals, the staff pre-appraisal and self-review steps on My Appraisals, and the HR review queue with training and feedback evidence.',
        component: Appraisals,
        tags: [
          'Appraisal',
          'Appraisals',
          'My Appraisals',
          'HR Review',
          'Performance',
          'Self-review',
        ],
      },
      {
        id: 'occupational-health',
        title: 'Occupational Health',
        summary:
          'Occupational health screening: the configurable staff questionnaire with BMI, immunisation evidence, fitness checks and COVID-19 risk assessment, flagged answers for HR review, requesting new screenings, and the optional shift-booking block.',
        component: OccupationalHealth,
        tags: [
          'Occupational Health',
          'Screening',
          'Health',
          'BMI',
          'Immunisations',
          'Vaccinations',
          'Fitness',
          'COVID-19',
          'Flags',
        ],
      },
    ],
  },
  {
    id: 'subcontractors',
    title: 'Subcontractors',
    pages: [
      {
        id: 'subcontractors',
        title: 'Subcontractors',
        summary:
          'Give external clinicians limited, time-boxed accounts: add and verify subcontractors, configure the access window, grant, extend, or revoke access, and archive accounts when an engagement ends.',
        component: Subcontractors,
        tags: [
          'Subcontractor',
          'Subcontractors',
          'External Staff',
          'Bank Staff',
          'Contractor',
          'Access Window',
          'Verification',
          'Revoke Access',
          'Clinical Role',
        ],
      },
      {
        id: 'working-with-subcontractors',
        title: 'Working with Subcontractors',
        summary:
          'Assign subcontractors to event, roster, PTS, and CAD shifts, cover a shift without a named account, and understand what subcontractors can do when they sign in, how their shifts appear in payroll, and your compliance responsibilities.',
        component: WorkingWithSubcontractors,
        tags: [
          'Subcontractor',
          'Subcontractors',
          'Shift Assignment',
          'Contractor Cover',
          'Clinical Tools',
          'ePCR',
          'VDI',
          'Payroll',
          'Compliance',
        ],
      },
    ],
  },
  {
    id: 'shifts',
    title: 'Shifts',
    pages: [
      {
        id: 'shifts',
        title: 'Shifts and Staff Work',
        summary:
          'Understand assigned shifts, available shifts, acknowledgements, declined roster shifts, applications, staff self-service tools, and subscribing to your shift calendar.',
        component: Shifts,
        tags: [
          'Shifts',
          'Available Shifts',
          'My Shifts',
          'Acknowledgement',
          'Applications',
          'My Work',
          'Calendar Feed',
          'iCal',
        ],
      },
      {
        id: 'shift-swaps',
        title: 'Shift Swaps',
        summary:
          'Offer an assigned shift as available for a colleague to take, apply for swapped shifts from Available Shifts, and review active swap requests and applications as a manager.',
        component: ShiftSwaps,
        tags: [
          'Shift Swap',
          'Swap Requests',
          'Reassignment',
          'Offer Shift',
          'Available Shifts',
          'Cover',
        ],
      },
    ],
  },
  {
    id: 'rostering-payroll',
    title: 'Rostering and Payroll',
    pages: [
      {
        id: 'rostering-payroll',
        title: 'Rostering, Availability, and Payroll',
        summary:
          'Plan draft rota plans, repeat roster shifts, manage availability and leave, add fixed shift bonuses, review overtime and expense claims, create and export pay runs (with VAT for registered invoice workers), and help staff understand pending pay, self-billing invoices, and statements.',
        component: RosteringPayroll,
        tags: [
          'Roster',
          'Rota',
          'Global Roster',
          'Availability',
          'Available Staff',
          'Annual Leave',
          'Holiday',
          'Payroll',
          'Pay Runs',
          'My Pay',
          'Pending Pay',
          'Contracted Hours',
          'Overtime',
          'On Call',
          'On-Call Rota',
          'Standby',
          'On-Call Number',
          'Repeat Shifts',
          'Copy Shift',
          'Bonuses',
          'Shift Bonuses',
          'Expenses',
          'Expense Claims',
          'VAT',
          'Self-billing',
          'Pay Run Export',
        ],
      },
      {
        id: 'workforce-scheduling-payroll',
        title: 'Full Workforce Workflow',
        summary:
          'Work through the full workforce workflow: draft rota plans, repeated shifts, available shifts, shift applications, acknowledgements, availability, holiday balances, overtime, expense claims, staff invoices and VAT, pay runs and CSV export, pending pay, and staff My Pay summaries.',
        component: WorkforceSchedulingPayroll,
        tags: [
          'Roster',
          'Rota',
          'Global Roster',
          'Availability',
          'Available Staff',
          'Annual Leave',
          'Holiday',
          'Payroll',
          'Pay Runs',
          'My Pay',
          'Pending Pay',
          'Contracted Hours',
          'Overtime',
          'Acknowledgement',
          'Repeat Shifts',
          'Copy Shift',
          'Expenses',
          'Staff Invoices',
          'VAT',
          'Self-billing',
          'Pay Run Export',
        ],
      },
    ],
  },
  {
    id: 'training-crew-vault',
    title: 'Training and Crew Vault',
    pages: [
      {
        id: 'mandatory-training-and-e-learning',
        title: 'Mandatory Training and E-learning',
        summary:
          'Set up mandatory training courses and the roles that need them, the e-learning courses staff take in AmbuNet, assessments and certificates, the training matrix, practical sign-offs, and expiry reminders.',
        component: MandatoryTrainingELearning,
        tags: ['Mandatory Training', 'E-learning', 'Training Matrix', 'Certificates', 'Courses', 'Compliance', 'CSTF', 'Assessment'],
      },
      {
        id: 'personal-tools-training-and-crew-vault',
        title: 'Personal Tools, Training, and Crew Vault',
        summary:
          'Use My Account (personal details, BACS, notification preferences, calendar feeds, and app preferences including a default landing page), 2FA and passkeys, the My Tasks board, the notifications page, Crew Vault, announcements, support, and e-learning.',
        component: PersonalTools,
        tags: [
          'My Account',
          '2FA',
          'Passkeys',
          'Preferences',
          'Landing Page',
          'Calendar Feeds',
          'iCal',
          'Tasks',
          'Task Board',
          'Notifications',
          'Crew Vault',
          'E-learning',
        ],
      },
    ],
  },
]
